export const iconFontAwesomeMediaplaybackCircleStop = (
	<i className="fa-solid fa-circle-stop"></i>
);
